import { classNames } from "utils/utils";
import { useTranslation } from "react-i18next";

const CardHeader = ({ leagueData }) => {
  const { t } = useTranslation();
  const {
    gameType,
    gameRule,
    scoreRule,
    leagueIcon,
    leagueFlag,
    name,
    settled,
    gameTypeId,
  } = leagueData;
  let gameModeLabel =
    scoreRule === 5 ? "LMS" : gameRule === 1 || gameRule === 3 ? "CS" : "1X2";
  let gameTypeText =
    gameType === 0
      ? t("common.gametypes.season")
      : t("common.gametypes.playoff");
  return (
    <div
      className={classNames(
        settled ? " via-black/40 from-black/70 " : " via-black/70 from-black ",
        "flex justify-between p-2 bg-gradient-to-b to-transparent"
      )}
    >
      <div className="flex items-center justify-center">
        <img
          src={leagueFlag ? leagueFlag : leagueIcon}
          className="rounded-full w-8 h-8 object-cover shrink-0"
          alt="Logo"
        />
        <div className="grid w-full overflow-hidden pl-2  flex-col">
          <div className="text-sm text-white truncate whitespace-nowrap font-semibold">
            {name}
          </div>
          <div className=" font-normal text-xs text-white truncate whitespace-nowrap -mt-0.5">
            {gameTypeId !== undefined
              ? t(
                  "createTournament.steps.setSelectedGame.types.titles." +
                    gameTypeId
                )
              : "-"}
          </div>
        </div>
      </div>

      <div className="flex justify-end items-end h-fit">
        <div
          className={classNames(
            "flex rounded-l-md text-black bg-white text-xs px-2 py-0.5 h-fit w-fit shadow-md"
          )}
        >
          {gameModeLabel}
        </div>

        <div
          className={classNames(
            gameType == 0 ? "bg-headerPrimary" : "bg-black",
            "flex rounded-r-md text-white text-xs px-2 py-0.5 h-fit w-fit "
          )}
        >
          {gameTypeText}
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
